import React from 'react'

import { Container } from 'components/atoms/container'
import { StyledContainer } from 'components/atoms/container/index.styled'
import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { StyledArticleContainer } from 'components/pages/homepage/index.styled'
import { domainLocales } from 'domainLocales'
import { IArticles } from 'interfaces/categories.interface'
import { Article } from 'interfaces/types'
import { useRouter } from 'next/router'
import styled from 'styled-components'

const ArticlesStyled = styled(StyledContainer)`
  padding: 24px 0;
  header {
    padding-left: 16px;
  }
  .sub-article {
    border-bottom: 1px solid ${(props) => props.theme.mbColors.lightGray};
  }
`

const SubArticles = ({ articles }: IArticles) => {
  const { locale } = useRouter()
  const sL = locale || 'vi-VN' // standardized locale

  return (
    <ArticlesStyled>
      <StyledArticleContainer className="articles-container">
        {articles?.map((article: Article, id: number) => (
          <Container key={article.id}>
            <ArticleCardWrapper
              className="sub-article"
              article={article}
              dataEventCategoryForTitle="Top Article Title"
              dataEventActionForTitle={`Click ${id + 1}`}
              dataEventLabelForTitle={`https://${domainLocales[sL]}${article.permalink}`}
              dataEventCategoryForBanner="Top Article Banner"
              dataEventActionForBanner={`Click ${id + 1}`}
              dataEventLabelForBanner={`https://${domainLocales[sL]}${article.permalink}`}
              dataEventCategoryForCategory="Top Category Title"
              dataEventActionForCategory={`Click ${id + 1}`}
              dataEventLabelForCategory={`https://${domainLocales[sL]}${article.category.permalink}`}
              type="author"
              size="md"
              banner={
                <img
                  loading="lazy"
                  src={article.featureImage || '/images/bmrThumbnail.png'}
                  alt={article.postTitle}
                />
              }
              categoryLink={article.category.permalink}
              articleLink={article.permalink}
              direction="horizontal"
              categoryName={article.category?.displayName}
              title={article.postTitle}
              text={''}
              styleLabel={{
                color: article.category.textColor,
              }}
              uploadTime={article.modifiedTime}
            />
          </Container>
        ))}
      </StyledArticleContainer>
    </ArticlesStyled>
  )
}

export default SubArticles
